import { lazy } from "react";
import { RouteObject } from "react-router-dom";

const EmailCampaigns = lazy(() => import("@/pages/agent/email/campaigns/EmailCampaigns/EmailCampaigns"));
const AddEmailCampaign = lazy(() => import("@/pages/agent/email/campaigns/AddEmailCampaign/AddEmailCampaign"));
const EditEmailCampaign = lazy(() => import("@/pages/agent/email/campaigns/EditEmailCampaign/EditEmailCampaign"));
const CloneEmailCampaign = lazy(() => import("@/pages/agent/email/campaigns/CloneEmailCampaign/CloneEmailCampaign"));
const EmailCampaignStats = lazy(() => import("@/pages/agent/email/campaigns/EmailCampaignStats/EmailCampaignStats"));

const EmailLists = lazy(() => import("@/pages/agent/email/email-lists/EmailLists/EmailLists"));
const AddEmailList = lazy(() => import("@/pages/agent/email/email-lists/AddEmailList/AddEmailList"));
const EditEmailList = lazy(() => import("@/pages/agent/email/email-lists/EditEmailList/EditEmailList"));
const ManageClients = lazy(() => import("@/pages/agent/email/email-lists/clients/ManageClients/ManageClients"));

const UnsubscribedClients = lazy(() => import("@/pages/agent/email/unsubscribed-clients/UnsubscribedClients"));
const EmailCampaignSettings = lazy(() => import("@/pages/agent/email/settings/EmailCampaignSettings"));

const Error404 = lazy(() => import("@/pages/Error404"));

const emailsRoutes: RouteObject[] = [
  {
    index: true,
    element: <Error404 />,
  },
  {
    path: "campaigns",
    children: [
      {
        index: true,
        element: <EmailCampaigns />,
      },
      {
        path: "new",
        element: <AddEmailCampaign />,
      },
      {
        path: ":id",
        element: <CloneEmailCampaign />,
      },
      {
        path: ":id/edit",
        element: <EditEmailCampaign />,
      },
      {
        path: ":id/stats",
        element: <EmailCampaignStats />,
      },
    ],
  },
  {
    path: "email-lists",
    children: [
      {
        index: true,
        element: <EmailLists />,
      },
      {
        path: "new",
        element: <AddEmailList />,
      },
      {
        path: ":id",
        element: <EditEmailList />,
      },
      {
        path: "clients",
        children: [
          {
            index: true,
            element: <ManageClients />,
          },
        ],
      },
    ],
  },
  {
    path: "unsubscribed-clients",
    children: [
      {
        index: true,
        element: <UnsubscribedClients />,
      },
    ],
  },
  {
    path: "settings",
    children: [
      {
        index: true,
        element: <EmailCampaignSettings />,
      },
    ],
  },
];

export default emailsRoutes;
